import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

// Local replacement for react-storefront/Spacer. A flex:1 spacer div.
const useStyles = makeStyles(
  {
    root: {
      flex: 1,
    },
  },
  { name: 'RSFSpacer' },
)

export default function Spacer(props) {
  const classes = useStyles(props)
  return <div className={classes.root} />
}
